/*
 * Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'guest-info-panel',
    templateUrl: './guest-info-panel.component.html',
    styleUrls: ['./guest-info-panel.component.less'],
    standalone: false
})
export class GuestInfoPanelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
